export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/http-worker.73adfc2e.worker.js");
}
